import React from "react";
import Alert from "./alert";

interface ErrorFallback
{
  error: any, 
  resetErrorBoundary: any
}

export function ErrorFallbackComponent(error: ErrorFallback) {
  const [open, setOpen] = React.useState(true);

  return (
    <div role="alert">
      <p>Application has encountered an error. Please try again later. If issue persists, please contact support.</p>
      <pre>{error.error.message}</pre>
      <button onClick={error.resetErrorBoundary}>Try again</button>
    </div>
    // <Alert message="Application has encountered an error. Please try again later." severity="error" open={open} setOpen={setOpen} ></Alert>
  )
}

// export class ErrorBoundary extends React.Component {
//     constructor(props: any) {
//       super(props);
//       this.state = { hasError: false };
//     }
  
//     static getDerivedStateFromError(error: any) {
//       // Update state so the next render will show the fallback UI.
//       return { hasError: true };
//     }
  
//     componentDidCatch(error: any, errorInfo: any) {
//       // You can also log the error to an error reporting service
      
//     }
  
//     render() {
//       if ((this.state as any).hasError) {
//         // You can render any custom fallback UI
//         return <h1>Something went wrong.</h1>;
//       }
  
//       return this.props.children; 
//     }
//   }